// Mutation hook - wyslanie nowego maila z dealu (WRITE_NEW, akcja composera).
// POST /api/ui/sales-crm/mailbox/send-from-deal/{dealId}
// Sprint 3 v4.1. Invaliduje notify-by-deal po sukcesie aby timeline odswiezylo.

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IPostSendFromDealRequest,
  IPostSendFromDealResponse
} from 'api/types/composer';

export interface IUsePostSendFromDealParams {
  dealId: number;
  body: IPostSendFromDealRequest;
}

const postSendFromDeal = (
  params: IUsePostSendFromDealParams
): Promise<IPostSendFromDealResponse> =>
  axios.post(`/sales-crm/mailbox/send-from-deal/${params.dealId}`, params.body);

export const usePostSendFromDeal = (
  options?: UseMutationOptions<IPostSendFromDealResponse, IError, IUsePostSendFromDealParams>
) => {
  const queryClient = useQueryClient();
  return useMutation<IPostSendFromDealResponse, IError, IUsePostSendFromDealParams>(
    postSendFromDeal,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(['sales-crm-notify', 'by-deal', variables.dealId]);
        await queryClient.invalidateQueries(['sales-crm-notify', 'threads', 'by-deal', variables.dealId]);
        options?.onSuccess?.(data, variables, context);
      }
    }
  );
};
